import { render, staticRenderFns } from "./mslNav.vue?vue&type=template&id=4bdcc62c&scoped=true"
import script from "./mslNav.vue?vue&type=script&lang=js"
export * from "./mslNav.vue?vue&type=script&lang=js"
import style0 from "./mslNav.vue?vue&type=style&index=0&id=4bdcc62c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdcc62c",
  null
  
)

export default component.exports